// extracted by mini-css-extract-plugin
export default {"tabs":"AnalysisSidebarTabs_tabs__-PHgg","tab":"AnalysisSidebarTabs_tab__BAj+-","tabActive":"AnalysisSidebarTabs_tabActive__W+Nrb"};